import { ForwardedRef, forwardRef, PropsWithChildren } from 'react';
import cn from 'classnames';
import { BoxProps } from '@mui/material';
import { StyledBox, StyledInfoIcon } from './styles';

const DiscountBanner = forwardRef(function DiscountBanner(
  props: PropsWithChildren<BoxProps>,
  ref: ForwardedRef<HTMLDivElement>,
) {
  const { children, ...restBoxProps } = props;

  return (
    <StyledBox
      {...restBoxProps}
      ref={ref}
      className={cn(restBoxProps.className, 'informa-payment-discount-banner')}
    >
      <StyledInfoIcon fontSize="small" />
      {children}
    </StyledBox>
  );
});

export default DiscountBanner;
